export default __webpack_public_path__ + "static/media/gallery-10-2.7478427f.jpg";